import { createClient, filter, asHTML } from '@prismicio/client';
import linkResolver from './prismic-link-resolver';

// Dépôt Prismic des articles de l'accueil (window.prismic est défini dans index.html, pour la barre d'outils Prismic)
export const client = createClient(window.prismic.endpoint);

export { filter };

export function richTextAsHtml(field) {
  return asHTML(field, { linkResolver });
}
